<template>
  <v-container full-width fluid ma-0 pa-0>
    <gh-table-page sort-by="Seq" :before-save="beforeSave" :tabs="tabs" ref="table" :args-query="argsQuery"
      module="portal.menu" cls="MenuService" @pageConfig="configPage" :beforeRowIntial="beforeIntial">
      <template #area_left>
        <v-layout column wrap>
          <gh-business-tree ref="tree" :attached-all="true" v-model="parent" module="portal.menu" cls="MenuService">
            <template v-slot="{node,data}">
              <v-icon small color="primary">{{data.icon}}</v-icon>{{data.Cd}}{{data.Name}}
            </template>
          </gh-business-tree>
        </v-layout>
      </template>
      <template #area_query>
      </template>
    </gh-table-page>
mdi-account-plus-outline
  </v-container>
</template>

<!-- <style scoped lang="less" src="./style.less"></style> -->

<script>
  import Menu from "./menu.ts";
  export default Menu;
</script>